export const broadcast = {
  jobModuleRunning: "Le module “{{moduleName}}” a débuté.",
  jobModuleCompleted: "Le module “{{moduleName}}” est terminé.",
  jobModuleFailed: "Le module “{{moduleName}}” a échoué.",
};
